import { CourseIndexInfo } from '@protos/content_management/content.common.apis_pb';
import { AssessmentTask } from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  AssessmentList,
  AssessmentListCountInfo,
  TeacherAssessmentClassStatsV2,
  TeacherAssessmentClassStatsV3,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { ModeOfConductionEnum } from '@protos/learning_management/lms.db_pb';
import { createSlice } from '@reduxjs/toolkit';
import { IUploadStatusMessage } from '../../Assessment/components/UploadQuestions/UploadErrorCard';
interface IQuestionPrompt {
  prompt: string;
  prompt_validated?: 'success' | 'error';
}
interface IQuestionUploadFilter {
  value: 'all' | 'teacher';
}
export interface IManageHomeworkState {
  // homework_list_data: HomeworkList | undefined;
  question_upload_filter?: IQuestionUploadFilter;
  ai_prompt_status?: IQuestionPrompt;
  question_Upload_errors?: IUploadStatusMessage[] | string[];
  assessment_list_data: AssessmentList | undefined;
  current_assessmemt_classStats?: TeacherAssessmentClassStatsV3;
  selected_assessment_id?: number;
  draft_homework?: { [pageNumber: number]: AssessmentTask[] };
  assigned_homework?: { [pageNumber: number]: AssessmentTask[] };
  ended_homework?: { [pageNumber: number]: AssessmentTask[] };
  manage_mode_of_conduction?: ModeOfConductionEnum;
  hw_info?: {
    hwListInfo: AssessmentListCountInfo | undefined;
    totalDraftPages: number;
    totalAssignedPages: number;
    totalEndedPages: number;
  };
  assessment_info?: {
    assessmentListInfo: AssessmentListCountInfo | undefined;
    totalDraftPages: number;
    totalAssignedPages: number;
    totalEndedPages: number;
  };
}

const initialState: IManageHomeworkState = {
  // homework_list_data: undefined,
  question_upload_filter: {
    value: 'all',
  },
  assessment_list_data: undefined,
  draft_homework: {},
  assigned_homework: {},
  ended_homework: {},
  hw_info: {
    hwListInfo: undefined,
    totalDraftPages: 1,
    totalAssignedPages: 1,
    totalEndedPages: 1,
  },
  assessment_info: {
    assessmentListInfo: undefined,
    totalDraftPages: 1,
    totalAssignedPages: 1,
    totalEndedPages: 1,
  },
};

export const manageHomeworkSlice = createSlice({
  name: 'manageHomework',
  initialState,
  reducers: {
    // setHomeworkListsData: (state, action) => {
    //   state.homework_list_data = action.payload;
    // },
    setQuestionUploadFilter: (state, action) => {
      state.question_upload_filter = action.payload;
    },
    setAiPromptStatus: (state, action) => {
      state.ai_prompt_status = action.payload;
    },
    setAssessmentListData: (state, action) => {
      state.assessment_list_data = action.payload;
    },

    setCurrentAssessmentClassStats: (state, action) => {
      state.current_assessmemt_classStats = action.payload;
    },
    setSelectedAssessmentId: (state, action) => {
      state.selected_assessment_id = action.payload;
    },
    setDraftData: (state, action) => {
      state.draft_homework = action.payload;
    },
    setAssignedData: (state, action) => {
      state.assigned_homework = action.payload;
    },
    setEndedData: (state, action) => {
      state.ended_homework = action.payload;
    },
    setHwInfoData: (state, action) => {
      state.hw_info = action.payload;
    },
    setAssessmentInfoData: (state, action) => {
      state.assessment_info = action.payload;
    },
    setModeOfConduction: (state, action) => {
      state.manage_mode_of_conduction = action.payload;
    },
    setQuestionUploadErrors: (state, action) => {
      state.question_Upload_errors = action.payload;
    },

    resetManageHWState: (state) => {
      return initialState;
    },
  },
});

export const {
  // setHomeworkListsData,
  setQuestionUploadFilter,
  setAiPromptStatus,
  setAssessmentListData,
  setQuestionUploadErrors,
  setSelectedAssessmentId,
  resetManageHWState,
  setCurrentAssessmentClassStats,
  setDraftData,
  setAssignedData,
  setEndedData,
  setHwInfoData,
  setAssessmentInfoData,
  setModeOfConduction,
} = manageHomeworkSlice.actions;
export default manageHomeworkSlice.reducer;
